import React from "react";
import { CssBaseline, AppBar, Toolbar, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Avatar from '@material-ui/core/Avatar';
import MenuIcon from "@material-ui/icons/Menu";
import IconButton from "@material-ui/core/IconButton";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import clsx from "clsx";
import Session from "react-session-api";
import Logo from "./../../media/images/icons/pm_logo.png";
import ProfilePage from "./ProfilePage";
const drawerWidth = 240;

export const Header = ({ IsNavOpen, handleDrawerOpen, handleLogOut }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, { [classes.appBarShift]: IsNavOpen })}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, { [classes.hide]: IsNavOpen })}
          >
            <MenuIcon />
          </IconButton>
          <div style={{ overflow: "hidden", width: "100%" }}>
            <div style={{ float: "left", padding: "0.5rem 0rem 0.5rem 0rem" }}>
              {!IsNavOpen && (
                <img
                  src={Logo}
                  alt="LOGO"
                  style={{ height: "70%", width: "70%" }}
                />
              )}
            </div>

            <div
              style={{
                float: "right",
                marginRight: "0.1rem",
                marginTop: "0.5rem",
              }}
            >
              <ProfilePage UserName = {Session.get("UserName")} handleLogOut={handleLogOut} />
              {/* <div style={{display:'flex',flexDirection:'row'}}>
                <Avatar alt={Session.get("UserName")} src="https://images.pexels.com/photos/20787/pexels-photo.jpg?auto=compress&cs=tinysrgb&h=350" />
                <div style={{display:'flex',flexDirection:'column'}}>
                  <Typography className={classes.usertext} noWrap>
                    {!IsNavOpen && "Welcome " + Session.get("UserName") + ","}
                  </Typography>
                  <IconButton
                    onClick={handleLogOut}
                    style={{ fontSize: 16, padding: 0, color: "white" }}
                  >
                    <ExitToAppIcon />
                    Sign Out
                  </IconButton>
                </div>
              </div> */}
            </div>
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },

  appBar: {
    width: "100%",
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    background: theme.palette.primary.gradient,
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
    color: "white",
  },
  hide: {
    display: "none",
  },
  headertext: {
    fontSize: 20,
    color: "white",
  },
  usertext: {
    color: "white",
  },
}));
